module.exports = __webpack_public_path__ + "static/media/fondo_fotografia.72b1638f.jpg";